import { ApiBaseService } from "./ApiBaseService";

interface CreditOptions {
    month: string;
    year: string;
}

export default class CreditService extends ApiBaseService {
    public usage(options: Partial<CreditOptions> = {}) {
        return this.request(this.route("api.credit.usage", "credit/usages"), {
            method: "GET",
            params: options,
        });
    }
}
